/* eslint-disable import/prefer-default-export */

export const DWOLLA_CUSTOMER_CHANGED = 'DWOLLA_CUSTOMER_CHANGED';
export const PLAID_ACCOUNT_LINKS_CHANGED = 'PLAID_ACCOUNT_LINKS_CHANGED';
export const VENUE_OWNERSHIPS_CHANGED = 'VENUE_OWNERSHIPS_CHANGED';
